import { defineComponent as _defineComponent } from 'vue'
import { OfferSingle } from "@/services/offers/OfferSingle";
import { postOfferParams } from "@/api/offers";
import { showNotification, showServerError } from "@/utils";
import FormLogo from "@/components/offers/offer/products/FormLogo.vue";
import FormTextField from "@/components/offers/offer/products/FormTextField.vue";
import FormSelect from "@/components/offers/offer/products/FormSelect.vue";
import FormLink from "@/components/offers/offer/products/FormLink.vue";
import FormRange from "@/components/offers/offer/products/FormRange.vue";
import { cloneDeep } from "lodash-es";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import { computed, onMounted, ref } from "vue";
import { IOfferProduct } from "@/api/types/offers";
import { EDITABLE_LOGO_PRODUCT_IDS } from "@/mappings/offer";
import { canEditOffers } from "@/utils/checkRole";

interface Props {
    offer: OfferSingle;
    product?: IOfferProduct;
    productId: number;
    urlId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferParamsForm',
  props: {
    offer: null,
    product: null,
    productId: null,
    urlId: null
  },
  emits: ['update'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
    offer: OfferSingle;
    product?: IOfferProduct;
    productId: number;
    urlId: number;
}




const isEdit = ref(false);
const form = ref([]);
const currentProduct = ref(null);
const oldProductParams = ref({});

const canEditOffer = computed(() => canEditOffers());

const mainCardTitle = computed(() => {
    if (!props.product) {
        return props.offer.products.find(i => i.id === props.productId)?.name || '';
    }
    return props.product.product.name;
});

const checkNumberForOdd = (number: number): boolean => {
    return number % 2 !== 0;
};

const getForm = async (): Promise<void> => {
    try {
        form.value = props.offer.offerParamsForms![props.productId];
    } catch (err) {
        showServerError(err, 'Параметры оффера не загружены');
    }
};

onMounted(() => {
    if (!props.productId) return;
    getForm();
    setProduct();
});

const setProduct = () => {
    // ранее заполненный/частично заполненный виджет
    const product = cloneDeep(props.product);
    // Костыль, когда параметров нет, приходит пустой массив, когда есть, тогда объект. Нужно преобразовать в объект.
    if (product?.params && Array.isArray(product.params) && !product.params.length) product.params = {};

    currentProduct.value = product || { product: { id: props.productId }, params: {} as any };
    if (product) oldProductParams.value = cloneDeep(product.params);
};

const editOfferParams = async (): Promise<void> => {
    try {
        if (JSON.stringify(oldProductParams.value) !== JSON.stringify(currentProduct.value.params)) {
            const productDTO = {
                product_id: currentProduct.value.product.id,
                params: currentProduct.value!.params,
                url_id: props.urlId,
            };
            if (!EDITABLE_LOGO_PRODUCT_IDS.includes(currentProduct.value.product.id)) {
                delete productDTO.params.logo_link!;
            }
            await postOfferParams(props.offer.legacy_id as number, productDTO);
            emit('update');
            showNotification('Параметры оффера сохранены');
        }
        isEdit.value = !isEdit.value;
    } catch (err) {
        showServerError(err, 'Параметры оффера не загружены');
    }
};

const editParams = () => {
    if (isEdit.value) {
        editOfferParams();
    } else {
        isEdit.value = !isEdit.value;
    }
};

const cancel = () => {
    isEdit.value = false;
    currentProduct.value.params = cloneDeep(oldProductParams.value);
};

const getComponent = (type: 'file' | 'text' | 'url' | 'object' | 'select' | 'multi_select'): any => {
    switch (type) {
    case 'file':
        return FormLogo;
    case 'object':
        return FormRange;
    case 'select':
    case 'multi_select':
        return FormSelect;
    case 'url':
        return FormLink;
    default:
        return FormTextField;
    }
};

expose({ setProduct });

return { __sfc: true,props, emit, isEdit, form, currentProduct, oldProductParams, canEditOffer, mainCardTitle, checkNumberForOdd, getForm, setProduct, editOfferParams, editParams, cancel, getComponent, BaseEditableCard }
}

})